import { eTICKETSTATUS, eTICKETSTATUSCOLORS } from "../utils/enum";

export const getStatusColor = (statusName: string | undefined): string => {
  switch (statusName?.toLocaleUpperCase()) {
    case eTICKETSTATUS.INPROGRESS:
      return eTICKETSTATUSCOLORS.INPROGRESS;
    case eTICKETSTATUS.VISITSCHEDULED:
      return eTICKETSTATUSCOLORS.VISITSCHEDULED;
    case eTICKETSTATUS.HOLDDELIVERYDEPENDENCY:
      return eTICKETSTATUSCOLORS.HOLDDELIVERYDEPENDENCY;
    case eTICKETSTATUS.HOLDSPAREDEPENDENCY:
      return eTICKETSTATUSCOLORS.HOLDSPAREDEPENDENCY;
    case eTICKETSTATUS.CLOSE:
      return eTICKETSTATUSCOLORS.CLOSE;
    case eTICKETSTATUS.UNASSIGNED:
      return eTICKETSTATUSCOLORS.UNASSIGNED;
    case eTICKETSTATUS.SERVICEENGINEERASSIGNED:
      return eTICKETSTATUSCOLORS.SERVICEENGINEERASSIGNED;
    case eTICKETSTATUS.HOLDAMCAPPROVALPENDING:
      return eTICKETSTATUSCOLORS.HOLDAMCAPPROVALPENDING;
    case eTICKETSTATUS.HOLDSPAREAPPROVALPENDING:
      return eTICKETSTATUSCOLORS.HOLDSPAREAPPROVALPENDING;
    default:
      return eTICKETSTATUSCOLORS.DEFAULT;
  }
};
